export default __webpack_public_path__ + "static/char-thumb-57-87baaac5f7ffa0915e7aca6005ded633.png";